import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { noop } from 'lodash';
import { FormattedMessage } from 'react-intl';
import { Button } from '../button';
import { sharpSansMedium, sharpSansSemibold } from '../typography';
import { navy, coral, grey25 } from '@zocdoc/branding/colors';
import { breakpoint } from '../grid';
import { Textbox } from '../textbox';

export default class TextMeTheAppForm extends PureComponent {
    static propTypes = {
        onChangePhoneNumber: PropTypes.func,
        textAppLink: PropTypes.func,
        trackChangePhoneNumber: PropTypes.func,
        trackClickPhoneNumber: PropTypes.func,
        trackClickTextAppLink: PropTypes.func,
    };

    static defaultProps = {
        onChangePhoneNumber: noop,
        textAppLink: noop,
        trackChangePhoneNumber: noop,
        trackClickPhoneNumber: noop,
        trackClickTextAppLink: noop,
    };

    handleClickPhoneNumber = () => {
        this.props.trackClickPhoneNumber();
    };

    handleChangePhoneNumber = number => {
        this.props.trackChangePhoneNumber(number);
        this.props.onChangePhoneNumber(number);
    };

    handleSubmit = () => {
        this.props.trackClickTextAppLink();
        this.props.textAppLink(this.props.phoneNumberFormatted);
    };

    maybeRenderMessage() {
        if (this.props.textSendError) {
            return (
                <TextFailedMessage data-test="text-app-failed-msg">
                    <FormattedMessage
                        defaultMessage="Enter a valid phone number"
                        id="Component.TextMeTheApp.Error"
                    />
                </TextFailedMessage>
            );
        }
        if (this.props.textSent && !this.props.textSendError) {
            return (
                <TextSuccessMessage data-test="text-app-success-msg">
                    <FormattedMessage
                        defaultMessage="Sweet! Please check your phone"
                        id="Component.TextMeTheApp.Message"
                    />
                </TextSuccessMessage>
            );
        }
    }

    render() {
        return (
            <div>
                <DownloadText data-test="text-me-app-title">
                    <FormattedMessage
                        defaultMessage="Send me a link to the app"
                        id="Home.SendAppLink"
                    />
                </DownloadText>
                <ControlContainer>
                    <FlexContainer>
                        <StyledTextbox
                            data-test="phone-number-textbox"
                            onChange={this.handleChangePhoneNumber}
                            onClick={this.handleClickPhoneNumber}
                            placeholder="(555) 555-5555"
                        />
                    </FlexContainer>
                    <Button onClick={this.handleSubmit}>
                        <FormattedMessage
                            defaultMessage="Send link"
                            id="Home.SendAppLink.SendLinkShort"
                        />
                    </Button>
                </ControlContainer>
                <TextResponseContainer>
                    { this.maybeRenderMessage() }
                </TextResponseContainer>
            </div>
        );
    }
}

const DownloadText = styled.div`
    ${sharpSansSemibold(15, 20)};
    padding-bottom: 10px;
`;

const StyledTextbox = styled(Textbox)`
    appearance: none;
    border: 0;
    
    &:focus::placeholder  {
        color: ${grey25};
    }
`;

const TextSuccessMessage = styled.label`
    ${sharpSansMedium(15, 24)}
    color: ${navy};
`;

const TextFailedMessage = styled.label`
    ${sharpSansMedium(15, 24)}
    color: ${coral};
`;

const TextResponseContainer = styled.div`
    min-height: 24px;
`;

const ControlContainer = styled.div`
    display: flex;

    ${breakpoint.medium} {
        width: 75%;
    }
`;

const FlexContainer = styled.div`
    flex: 1;
`;
